import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import Grid from '@material-ui/core/Grid';
import DetailsCard from '../../../global/DetailsCard'
import PersonIcon from '@material-ui/icons/Person';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import UsersTable from './UsersTable';
import {DashboardStyles} from './DashboardStyles';

import {getUsers, getAdmins, getKuliahs} from './dashboard.actions';

 const AdminDashboard = (props, state) => {
  
  useEffect(() => {
   props.getUsers()
   props.getAdmins()
  }, []);

    return (
        <Grid>
        <Grid container spacing={2}>
        <Grid item xs>
        <DetailsCard text={'Current Active Users'} number={props.users.length} icon= {<PersonIcon style={DashboardStyles.iconColor}/>}/>
        </Grid>
        <Grid item xs>
        <DetailsCard text={'Current Admins'} number={props.admins.length}  icon= {<SupervisorAccountIcon style={DashboardStyles.iconColor}/>}/>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <h2 style={DashboardStyles.headingColor}>Users</h2>
          <UsersTable data= {props.users}/>
        </Grid>
      </Grid>
      </Grid>
        );
}

const mapDispatchToProps = dispatch => {
  return {
    // dispatching plain actions
    getUsers: () => dispatch(getUsers()),
    getAdmins: () => dispatch(getAdmins()),
    getKuliahs: () => dispatch(getKuliahs()),
  }
}

const mapStateToProps =(state, ownProps, number)  =>({
      text: ownProps.text,
      icon: ownProps.icon,
      number: ownProps.number,
      users : state.dashboardReducer.users,
      admins : state.dashboardReducer.admins,
      kuliahs : state.dashboardReducer.kuliahs
    })

export default connect(mapStateToProps,mapDispatchToProps)(AdminDashboard);